// app/javascript/controllers/listing_form_controller.js
// Drives the owner listing form: show/hide rent vs sale sections by listing
// type, and add/remove nested availability + extra-cost rows from <template>s.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "section", "typeCard",
    "availabilities", "availabilityTemplate",
    "extraCosts", "extraCostTemplate"
  ]

  connect() {
    this.toggleSections()
  }

  selectedType() {
    const checked = this.element.querySelector('input[name="listing[listing_type]"]:checked')
    return checked ? checked.value : "rent_only"
  }

  toggleSections() {
    const type = this.selectedType()
    const rentable = type === "rent_only" || type === "rent_and_sale"
    const saleable = type === "sale_only" || type === "rent_and_sale"

    this.sectionTargets.forEach((section) => {
      const kind = section.dataset.section
      const show = kind === "rent" ? rentable : saleable
      section.classList.toggle("hidden", !show)
    })

    // Highlight the selected type card
    this.typeCardTargets.forEach((card) => {
      const active = card.dataset.type === type
      card.classList.toggle("border-indigo-600", active)
      card.classList.toggle("bg-indigo-50", active)
      card.classList.toggle("border-gray-200", !active)
    })
  }

  addAvailability(event) {
    event.preventDefault()
    this.appendFrom(this.availabilityTemplateTarget, this.availabilitiesTarget, "NEW_AVAIL")
  }

  addExtraCost(event) {
    event.preventDefault()
    this.appendFrom(this.extraCostTemplateTarget, this.extraCostsTarget, "NEW_EXTRA")
  }

  // Rails fields_for renders the template with a placeholder child_index; swap
  // it for a unique value so the new row submits as its own record.
  appendFrom(template, container, placeholder) {
    const html = template.innerHTML.replaceAll(placeholder, Date.now().toString())
    container.insertAdjacentHTML("beforeend", html)
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest('[data-listing-form-target="row"]')
    if (!row) return

    // Persisted rows render a hidden [id] field; mark them for deletion so the
    // server removes them. New rows have no id — just drop them from the DOM.
    const idField = row.querySelector('input[name$="[id]"]')
    const destroy = row.querySelector('input[data-listing-form-target="destroy"]')
    if (idField && idField.value && destroy) {
      destroy.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }
}
